import type { FC } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Button, NavItemBadge } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { BADGE_ITEMS } from "app/components/sidebar3/types";
import { translate } from "app/filters/i18nFilter";
import { AssetsService } from "app/services/AssetsService";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { ButtonsContainer, Container, ContentContainer, LeftContainer, TitleContainer } from "./styledComponent";

interface ILobFoldersBanner {
    mainSite: string;
    onClose: () => void;
}
const LobFoldersBanner: FC<ILobFoldersBanner> = ({ mainSite, onClose }) => {
    const handleClose = () => {
        allTrackers.dispatchTrackEvent("Button", "click", "LOB banner/dismiss", {
            mainSite,
        });
        onClose();
    };

    const handleAnalyzeClick = () => {
        allTrackers.dispatchTrackEvent("Button", "click", "LOB banner/analyze", {
            mainSite,
        });
        proNavigator.go("digitalsuite_website_content", {
            selectedTab: "LOB",
        });
    };

    return (
        <Container>
            <LeftContainer>
                <ContentContainer>
                    <TitleContainer>
                        <Text
                            fontVariant="h5_2"
                            color={colorsPalettes.carbon[500]}
                        >
                            {translate("folders.analysis.lob.banner.title")}
                        </Text>
                        <NavItemBadge type={BADGE_ITEMS.NEW} />
                    </TitleContainer>
                    <Text
                        fontVariant="body2"
                        color={colorsPalettes.carbon[500]}
                    >
                        {translate("folders.analysis.lob.banner.subtitle")}
                    </Text>
                </ContentContainer>
                <ButtonsContainer>
                    <Button
                        type="outlined"
                        onClick={handleAnalyzeClick}
                    >
                        {translate(`folders.analysis.lob.banner.analyze.btn`, { domain: mainSite })}
                    </Button>
                    <Button
                        type="flat"
                        onClick={handleClose}
                    >
                        {translate("folders.analysis.lob.banner.dismiss.btn")}
                    </Button>
                </ButtonsContainer>
            </LeftContainer>
            <img
                width={321}
                src={AssetsService.assetUrl("/images/folders/lob-visualization.png")}
                alt="folders_lob_banner"
            />
        </Container>
    );
};

export default LobFoldersBanner;
